<ion-content class="coach-request-income-wrap">
    <ion-header class="absolute">
        <app-header [backRoute]="['/team']"></app-header>
    </ion-header>
        <div *ngIf="modalIsVisible" class="modal-overlay">
            <form class="modal" [formGroup]="profileForm" (ngSubmit)="onSubmit()" novalidate>
                <div class="close-btn"><span
                        class="my-color-blue">{{currentItem !== null && currentItem.status === 'cancelled'
                    ? ('__REQUESTS_CANCELATION_NOTE__' | translate)
                    : ('__REQUESTS_RESCHEDULING_NOTE__' | translate) }}</span><img
                        (click)="modalClose()" src="assets/img/close-btn.svg" /></div>

                <span class="reason" *ngIf="currentItem !== null">{{currentItem.status === 'rejected'
                    ? (currentItem.coach.full_name + ' (Coach)' | translate)
                        : (currentItem.delegate.full_name  + ' (Delegate)' | translate) }}: {{currentItem.reason}}
                    <br />
                    <br />
                    <strong>{{'__COACH_MESSAGE_SENT__' | translate}} {{currentItem.updated_at | amDateFormat: 'D/MM/YYYY'}}</strong>
                </span>
                <textarea *ngIf="currentItem === null" formControlName="reason" rows="10" cols="20"
                          placeholder="{{'__REQUESTS_RESCHEDULING_NOTE_PLACEHOLDER__' | translate}}"
                          [@headShake]="profileForm.controls['reason'].invalid && animationState"></textarea>

                <button *ngIf="currentItem === null" type="submit"
                        class="btn-rounded-blue ordinary-font-size primary-bg-color"><span>{{'__REQUESTS_RESCHEDULE_SUBMIT__' | translate}}</span></button>
            </form>
        </div>

        <div class="bg bg-{{userService.companyHeader}}" [ngClass]="{'mobile-bg': platform == 'mobile'}" [@enter]>
        </div>
        <div class="shadow-container">
            <div class="appointment my-color-blue">{{'__REQUESTS_APPOINT_REQUESTS__' | translate}}</div>
            <div class="note-for-delegate">
                <div class="first-row" [innerHTML]="'__REQUESTS_APPOINT_INTRO__' | translate"></div>
                <div class="second-row" [innerHTML]="'__REQUESTS_APPOINT_INTRO_NOTE__' | translate"></div>
            </div>
            <div class="notifications">
                <div class="text">{{ "__COACH_SHOW_COMPLETED__" | translate }}</div>
                <ion-toggle class="black-toggle"
                            [checked]="isShowCompleted"
                            (ionChange)="isShowCompleted = !isShowCompleted"
                            [attr.data-label-on]="'__ION_TOGGLE_YES__' | translate"
                            [attr.data-label-off]="'__ION_TOGGLE_NO__' | translate"
                            mode="ios"></ion-toggle>
            </div>
            <hr />
            <div class="appoints-container" *ngIf="appointmentsList">
                <div class="table-header">
                    <div style="margin-left: 1rem">{{'__REQUESTS_APPOINT_COACHEE__' | translate}}</div>
                    <div>{{'__REQUEST_APPOINT_DETAILS__' | translate}}</div>
                    <div style="text-align: center">{{'__REQUEST_APPOINT_STATUS__' | translate}}</div>
                    <div style="text-align: center; padding: 0 1rem">{{'__TYPE__' | translate}}</div>
                    <div></div>
                </div>
                <div class="appoint" *ngFor="let item of appointmentsList | filter : 'isPassed' : false : isShowCompleted ? 'ignore' : 'equals'">
                    <div class="name">
                        <div class="profile-photo">
                            <img *ngIf="item.delegate.avatar === null" src="assets/img/user-blue.svg"/>
                            <img *ngIf="item.delegate.avatar !== null" [src]="item.delegate.avatar.url"/>
                            <div class="link" (click)="goToProfile(item.delegate.id)">{{"__COACH_VIEW__" | translate }}</div>
                        </div>
                        <div class="profile-name">
                            <div class="my-color-blue">{{item.delegate.full_name}}</div>
                            <div class="profile-company">{{item.delegate.company_name}}</div>
                        </div>
                    </div>
                    <div class="session-details">
                        <button class="link button" (click)="goToProfile(item.delegate.id)">{{ "__COACH_VIEW_PROFILE__" | translate }}</button>
                        <div class="date"><span>{{'__COACH_APPOINT_DATE__' | translate}}</span>{{item.start_at | amDateFormat: 'dddd Do MMMM, y'}}</div>
                        <div class="time"><span>{{'__COACH_APPOINT_TIME__' | translate}}</span>{{item.start_at | date : 'HH:mm'}} - {{item.end_at | date : 'HH:mm'}}</div>
                        <div class="title"><span>{{'__COACH_APPOINT_TITLE__' | translate}}</span>{{item.title}}</div>
                        <div class="type"><span>{{'__TYPE__' | translate}}: </span>{{getTitleByCode(item.meeting_type)  | translate}}</div>
                    </div>
                    <div class="status-container">
                        <span *ngIf="item.status === 'completed'">{{ '__STATUS_APPOINT_COMPLETED__' | translate }}</span>
                        <span *ngIf="item.status === 'confirmed'">{{'__STATUS_APPOINT_CONFIRM__' | translate}}</span>
                        <span
                            *ngIf="item.status === 'pending'">{{'__STATUS_APPOINT_AWAIT_CONFIRM__' | translate}}</span>
                        <span *ngIf="item.status === 'cancelled'">{{'__STATUS_APPOINT_CANCELLED__' | translate}}</span>
                        <span *ngIf="item.status === 'rejected'">{{'__STATUS_APPOINT_REJECTED__' | translate}}</span>
                        <div class="round-status"
                            [ngClass]=" {'green': item.status === 'confirmed' || item.status === 'completed', 'yellow': item.status === 'pending', 'red': ( item.status === 'cancelled' || item.status === 'rejected')}">
                            <img src="assets/img/icon-await-confirm.svg" *ngIf="item.status === 'pending'"
                                [ngClass]=" {'yellow': item.status === 'pending' }" />
                            <img src="assets/img/icon-confirm-white.svg" *ngIf="item.status === 'confirmed' || item.status === 'completed'" />
                            <img src="assets/img/icon-cancel.svg"
                                *ngIf="item.status === 'cancelled' || item.status === 'rejected'" />
                        </div>
                    </div>
                    <div class="type-container">
                        <span>{{getTitleByCode(item.meeting_type)  | translate}}</span>
                    </div>
                    <div class="button-container">
                        <button class="join-session" [ngClass]="{active: joinSessionButtonActive(item)}" (click)="joinSession(item)"
                            *ngIf="item.status === 'confirmed' &&  item.meeting_type !== 'face2face'" [disabled]="!joinSessionButtonActive(item)">
                            <img src="assets/img/join-session.svg" />
                            <span>{{'__BUTTON_JOIN_SESSION__' | translate}}</span>
                        </button>

                        <button class="join-session face2face" [ngClass]="{active: joinSessionButtonActive(item)}"
                                *ngIf="item.status === 'confirmed' && item.meeting_type === 'face2face'">
                            <img src="assets/img/face2face.svg" />
                            <span>{{'__BUTTON_JOIN_SESSION__' | translate}}</span>
                        </button>

                        <button *ngIf="item.status ==='pending'" class="accept-booking" (click)="acceptBooking(item)">
                            <img class="green-btn" src="assets/img/accepted-green.svg" />
                            <span>{{'__BUTTON_ACCEPT_BOOK__' | translate}}</span>
                        </button>
                        <button class="request-reschedule" (click)="cancelAppointment(item)"
                            *ngIf='item.status === "confirmed" || item.status === "pending" '>
                            <img src="assets/img/icon-reschedule.svg" />
                            <span>{{'__BUTTON_REQUEST_RESCHEDULE__' | translate}}</span>
                        </button>
                        <button class="cancel-session" (click)="viewNote(item)"
                            *ngIf='item.status === "cancelled" || item.status === "rejected" '>
                            <img src="assets/img/icon-note-cancel.svg" />
                            <span>{{'__BUTTON_VIEW_NOTE__' | translate}}</span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="appoints-container" *ngIf="!appointmentsList">
                <div class="appoint" *ngFor="let width of [1,2,3]">
                    <div class="name my-color-blue">
                        <ion-skeleton-text animated style="width: 10rem; height: 1.5rem"></ion-skeleton-text>
                    </div>
                    <div class="session-details">
                        <div class="date"><ion-skeleton-text animated style="width: 13rem; height: 1rem"></ion-skeleton-text></div>
                        <div class="time"><ion-skeleton-text animated style="width: 13rem; height: 1rem"></ion-skeleton-text></div>
                        <div class="title"><ion-skeleton-text animated style="width: 13rem; height: 1rem"></ion-skeleton-text></div>
                    </div>
                    <div class="status-container">
                        <ion-skeleton-text animated style="height: 1rem; width: 5rem"></ion-skeleton-text>
                        <div class="round-status">
                            <ion-skeleton-text animated></ion-skeleton-text>
                        </div>
                    </div>
                    <div class="status-container">
                        <ion-skeleton-text animated style="height: 1rem; width: 7rem"></ion-skeleton-text>
                        <ion-skeleton-text animated style="height: 1rem; width: 7rem"></ion-skeleton-text>
                    </div>
                    <div class="button-container">
                        <ion-skeleton-text animated style="height: 5rem; width: 5rem"></ion-skeleton-text>
                    </div>
                </div>
            </div>
        </div>
        <app-footer-logo></app-footer-logo>

</ion-content>
